"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionPanelType = void 0;
var SelectionPanelType;
(function (SelectionPanelType) {
    SelectionPanelType["SINGLE"] = "SINGLE";
    SelectionPanelType["MULTI"] = "MULTI";
})(SelectionPanelType = exports.SelectionPanelType || (exports.SelectionPanelType = {}));
//# sourceMappingURL=SelectionPanelProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectionPanel/SelectionPanelProps.js
// module id = 560
// module chunks = 8